export default (httpClient) => ({
  
  
  buscarPorSKU: async ({ mlb, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pedido-por-id/" + mlb, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  buscarPorPagina: async ({ mlbs, token, cliente_id }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/produtos-por-array",
      { mlbs, cliente_id },
      { headers }
    );
    return {
      data: response.data,
    };
  },

  contarProdutos: async ({ seller_id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/produtos-por-seller/" + seller_id, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  listarProdutos: async ({ cliente_id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get(
      "/produtos-por-seller/" + cliente_id,
      { headers }
    );
    return {
      data: response.data,
    };
  },

  maisVendidos: async ({ cliente_id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/mais-vendidos/" + cliente_id, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  porArraySimples: async ({ cliente_id, token, mlbs, dias }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/produtos-por-array-simples/" + cliente_id,
      { mlbs, dias },
      { headers }
    );
    return {
      data: response.data,
    };
  },

  categoriasCliente: async ({ cliente_id, token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/categorias-cliente/" + cliente_id, {
      headers,
    });
    return {
      data: response.data,
    };
  },
  atualizarProdutos: async ({ token, pagina }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/atualizar-produtos", { headers });
    return {
      data: response.data,
    };
  },

  importarProdutos: async ({ token, pagina }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/importar-produtos/" + pagina, {
      headers,
    });
    return {
      data: response.data,
    };
  },

  pacotesDoDia: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia-embalar", {
      headers,
    });
    return {
      data: response.data,
    };
  },
});
